import { restApi } from '../../../api/restApiSlice';
import { appendDayScopeParams, type DiscoverabilityDayScope } from './discoverabilityDayScope';

export type DiscoverabilityChartQueryParams = DiscoverabilityDayScope;

export type DiscoverabilityChartPoint = {
  date: string;
  crawlers: Record<string, number>;
  all: number;
};

export type PagesCrawledChartResponse = {
  data: DiscoverabilityChartPoint[];
};

// Only the error-rate endpoint reports which crawlers had traffic in the
// range, so the chart can show a flat 0% line instead of hiding them.
export type ErrorRateChartResponse = PagesCrawledChartResponse & {
  activeCrawlers: string[];
};

export type DiscoverabilityChartResponse = PagesCrawledChartResponse | ErrorRateChartResponse;

const discoverabilityChartsApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    getPagesCrawledChart: builder.query<PagesCrawledChartResponse, DiscoverabilityChartQueryParams>({
      query: (params) => {
        const search = new URLSearchParams();
        appendDayScopeParams(search, params);
        return {
          url: `/v3/ai-insights/discoverability/charts/pages-crawled?${search.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['DiscoverabilityCharts'],
    }),
    getErrorRateChart: builder.query<ErrorRateChartResponse, DiscoverabilityChartQueryParams>({
      query: (params) => {
        const search = new URLSearchParams();
        appendDayScopeParams(search, params);
        return {
          url: `/v3/ai-insights/discoverability/charts/error-rate?${search.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['DiscoverabilityCharts'],
    }),
  }),
});

export { discoverabilityChartsApi };
export const {
  useGetPagesCrawledChartQuery,
  useGetErrorRateChartQuery,
} = discoverabilityChartsApi;
